import { render, staticRenderFns } from "./Zfkp.vue?vue&type=template&id=467ebee6&scoped=true"
import script from "./Zfkp.vue?vue&type=script&lang=js"
export * from "./Zfkp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467ebee6",
  null
  
)

export default component.exports